import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { postReviewLoad, postReviewReset } from '../../../../actionCreators/review';
import Stars from '../../../../CommonComponents/StarRating/StarRating';
import { required, email, minLength } from '../../../../utils/validation';
import './reviewList.scss';
import BootstrapSuccessError from '../../BootstrapSuccessError/BootstrapSuccessError';
import BlankLoader from '../../BlankLoader/BlankLoader';
import { composeValidators } from '../../../../utils/helper';

let rating = null;
function WriteReview(props) {
  const { showReviewFn, dataLocale, reviewConfig } = props;
  const dispatch = useDispatch();
  const {
    WRITE_A_REVIEW,
    REVIEW,
    TITLE,
    YOUR_NAME,
    POST_REVIEW,
    ENTER_EMAIL_ID,
    HOW_WOULD_YOU_RATE_PRODUCT,
    PLEASE_PROVIDE_US_RATING,
  } = dataLocale;
  const { postReviewProccessing, postReviewData } = useSelector(state => state.review);
  const [showRaingEror, setShowRatingError] = useState(false);
  let timerSuccess = null;
  let timerError = null;
  const minCharacterRequired = reviewConfig?.review_min_character || '6';
  useEffect(() => {
    return () => {
      rating = null;
      dispatch(postReviewReset());
    };
  }, []);

  useEffect(() => {
    if (postReviewData?.result?.message) {
      timerSuccess = setTimeout(() => {
        const p = document.getElementById('write-review-pdp');
        rating = null;
        dispatch(postReviewReset());
        if (p) {
          showReviewFn();
        }
      }, 3000);
    }
    return () => {
      window.clearTimeout(timerSuccess);
      window.clearTimeout(timerError);
    };
  }, [postReviewData]);

  const submitReview = (value, valid) => {
    if (rating && valid) {
      const { productId } = props;
      const obj = {
        productId,
        postObj: {
          email: value?.email,
          review: {
            noOfStars: rating,
            reviewDetail: value?.reviewDetail,
            reviewTitle: value?.reviewTitle,
            reviewee: value?.reviewee,
          },
        },
      };
      dispatch(postReviewLoad(obj));
    } else if (!rating) {
      setShowRatingError(true);
      timerError = setTimeout(() => {
        setShowRatingError(false);
      }, 3000);
    }
  };

  const getRating = value => {
    rating = value;
  };

  return (
    <div className="write-review-container" id="write-review-pdp">
      <div className="display-flex clear-both flex-direction-column flex-row align-items-center margin-b20">
        <div className="review-title w100 fs28">{WRITE_A_REVIEW}</div>
        <div onClick={() => showReviewFn()}>
          <img alt="close" className="cursor-pointer" src="/assets/svg/Cross.svg" />
        </div>
      </div>
      {!postReviewData?.result?.message && <h2 className="fs16">{HOW_WOULD_YOU_RATE_PRODUCT}</h2>}
      {postReviewData?.error && (
        <BootstrapSuccessError message={postReviewData?.error} type="error" />
      )}
      {postReviewData?.result?.message && (
        <BootstrapSuccessError message={postReviewData?.result?.message} type="success" />
      )}
      {showRaingEror && <BootstrapSuccessError message={PLEASE_PROVIDE_US_RATING} type="error" />}
      {!postReviewData?.result?.message && (
        <Stars getRating={value => getRating(value)} ratingid="review-form" writeAReview="true" />
      )}

      {!postReviewData?.result?.message && (
        <Form
          noValidate
          autoComplete="off"
          autoCorrect="off"
          render={({ handleSubmit, values, valid }) => {
            return (
              <form className="form-SLA margin-t30" onSubmit={handleSubmit}>
                <div className="margin-t20 wd-100">
                  <Field name="email" validate={composeValidators(required, email)}>
                    {({ input, meta }) => (
                      <div
                        className={`${meta.touched && meta.error ? 'has-error' : ''} margin-b30`}
                      >
                        <input
                          className="form-control"
                          {...input}
                          autoComplete="off"
                          placeholder={ENTER_EMAIL_ID}
                          type="text"
                        />
                        {meta.touched && meta.error && (
                          <div className="help-block with-errors">{meta.error}</div>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
                <div className="review-form-row margin-b5 display-flex">
                  <div>
                    <Field name="reviewee" validate={required}>
                      {({ input, meta }) => (
                        <div
                          className={
                            meta.touched && meta.error ? 'has-error margin-b10' : 'margin-b10'
                          }
                        >
                          {/* <label className="control-label">
                                                    {YOUR_NAME}
                                                </label> */}
                          <input
                            className="form-control"
                            {...input}
                            autoComplete="off"
                            placeholder={YOUR_NAME}
                            type="text"
                          />
                          {meta.touched && meta.error && (
                            <div className="help-block with-errors">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="margin-l20">
                    <Field name="reviewTitle" validate={required}>
                      {({ input, meta }) => (
                        <div
                          className={
                            meta.touched && meta.error ? 'has-error margin-b10' : 'margin-b10'
                          }
                        >
                          {/* <label className="control-label">
                                                    {TITLE}
                                                </label> */}
                          <input
                            className="form-control"
                            {...input}
                            autoComplete="off"
                            placeholder={TITLE}
                            type="text"
                          />
                          {meta.touched && meta.error && (
                            <div className="help-block with-errors">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="margin-t20 wd-100">
                  <Field name="reviewDetail" validate={minLength(minCharacterRequired)}>
                    {({ input, meta }) => (
                      <div
                        className={
                          meta.touched && meta.error ? 'has-error margin-b10' : 'margin-b10'
                        }
                      >
                        {/* <label className="control-label">
                                                {REVIEW}
                                            </label> */}
                        <textarea
                          className="form-control review-textarea"
                          {...input}
                          autoComplete="off"
                          placeholder={REVIEW}
                          type="text"
                        />
                        {meta.touched && meta.error && (
                          <div className="help-block with-errors">{meta.error}</div>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
                <div className="margin-t40 text-center">
                  {!postReviewProccessing && (
                    <button
                      className="btn-submit btn btn-main"
                      type="submit"
                      onClick={() => submitReview(values, valid)}
                    >
                      {POST_REVIEW}
                    </button>
                  )}
                  {postReviewProccessing && <BlankLoader />}
                </div>
              </form>
            );
          }}
          onSubmit={submitReview}
        />
      )}
    </div>
  );
}
export default WriteReview;
